import * as yup from "yup";
import { CostCenter, Customer, UserContexts } from "~/application/types";

export const costCenterSchema = yup.object().shape({
  name: yup.string().required("O nome da centro de custo é obrigatório"),
  costCenterCode: yup.string().required("O código de integração externa é obrigatório"),
  markAllBranches: yup.boolean().nullable(),
  branches: yup.array().of(
    yup.object().shape({
      uuid: yup.string().required(),
      name: yup.string().required(),
    }),
  ),
});

export type CostCenterSchema = yup.InferType<typeof costCenterSchema>;

export const defaultFormManager = (
  data?: CostCenter,
  contexts?: UserContexts,
  customer?: Customer,
) => {
  if (!data?.belongsToHeadquarters) return data;

  const customerDefault = contexts?.customer || customer;

  return {
    ...data,
    branches: [
      { ...customerDefault, name: `${customerDefault?.tradingName} (Matriz)` },
      ...(data?.branches || []),
    ].filter((branch) => branch?.uuid),
  };
};
